import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  setSearch,
  setCountryData,
  setSearchResults,
} from "../../../../store/search/searchSlice";
import { Countries } from "../../Home/CountryFlag";

/* Running a directory search, in one place. */
export const MIN_QUERY = 3;
export const TOO_SHORT = "Please enter at least 3 characters.";

export const defaultCountry = () => {
  const ae = Countries.find((c) => c.code === "AE");
  return ae ? { name: ae.name, flag: ae.file_url, code: ae.code } : null;
};

export const useCompanySearch = ({ resultsPath = "/search" } = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { countryData } = useSelector((state) => state.search);

  /* Returns the error to show, or null when the search ran. The caller owns
     where that message is rendered. */
  const search = useCallback(
    (raw, country) => {
      const value = String(raw || "").trim();
      if (value.length < MIN_QUERY) return TOO_SHORT;

      dispatch(setSearchResults([]));
      dispatch(setSearch(value));
      dispatch(setCountryData(country || countryData || defaultCountry()));
      navigate(resultsPath);
      return null;
    },
    [dispatch, navigate, resultsPath, countryData]
  );

  return { search };
};

export default useCompanySearch;
